// extracted by css-extract-rspack-plugin
export default {"rating":"Rating-module__rating___gFOJ8"};